module.exports = __webpack_public_path__ + "static/media/get-started-family.fe5f28cd.svg";